import { parse } from 'date-fns';

// Take the month, day, and year of what is entered, and set the time to UTC Midnight.
// Example, user entered May 13th, 2021 in California where it currently 10:00:00.
// We will be saving it as May 13th, 2021 at 00:00:00 UTC Time.
// Old code converted date to midnight for the user's local timezone which caused timezone issues and incorrect dates to display
export function getUTCTimeFromDateString(dateString: string) {
  if (!dateString) {
    return null;
  }
  const date = parse(dateString);
  date.setUTCHours(0, 0, 0, 0);
  return date.getTime().toString();
}
